import { useRecruiterBookingFlowContext } from "../../hooks/useRecruiterBookingFlowContext";
import { RecruiterScreeningBookingLandingContent } from "./RecruiterScreeningBookingLandingContent";
import { RecruiterScreeningCallMeNowContent } from "./RecruiterScreeningCallMeNowContent";

export function RecruiterScreeningCallModalContent() {
  const { path } = useRecruiterBookingFlowContext();

  switch (path) {
    case "landing": {
      return <RecruiterScreeningBookingLandingContent />;
    }

    case "call-me-now": {
      return <RecruiterScreeningCallMeNowContent />;
    }

    case "schedule-for-later": {
      // Not implemented yet
      return null;
    }

    default: {
      return null;
    }
  }
}
